import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Form } from "react-bootstrap";
//import Stack from 'react-bootstrap/Stack'
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { AuthContext } from "../context/AuthContext";

import { useTable } from "react-table";
import styled from "styled-components";
import { Link } from "react-router-dom";

import Brightness1Icon from "@mui/icons-material/Brightness1";

import { Modal } from "react-bootstrap";

//import TimePicker from "rc-time-picker";

//import parser from "cron-parser";

//import SelectWorkers from "../components/SelectWorkers";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import Box from "@mui/material/Box";

//import { Calendar, momentLocalizer, Views } from "react-big-calendar";
//import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
//import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

//import "react-big-calendar/lib/css/react-big-calendar.css";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
//import CardActions from '@mui/material/CardActions'
import CardContent from "@mui/material/CardContent";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import SearchIcon from "@mui/icons-material/Search";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SendIcon from "@mui/icons-material/Send";

import { useTranslate } from "../lib/translate/i18n/useTranslate";

import { getURLAPI } from "../utils/getURL";

import { default as Spinner } from "../components/Spinner";

//import { useHotkeys } from "react-hotkeys-hook";
//*********** */

//import { CssVarsProvider, extendTheme } from "@mui/joy/styles";
//import { RadioGroup as RadioGroup2 } from "@mui/joy";
//import { Radio as Radio2 } from "@mui/joy";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import AccessAlarm from "@mui/icons-material/AccessAlarm";
import EnhancedEncryptionIcon from "@mui/icons-material/EnhancedEncryption";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

//import MuiPhoneNumber from "material-ui-phone-number";

//import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
//import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
//import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

//import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/ru";
import "dayjs/locale/uk";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

//import { useForm } from "../hooks/remote";
import GridTable from "../lib/react-grid-table/index";

import moment from "moment";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import ReactPanZoom from "react-image-pan-zoom-rotate";

import Draggable from "react-draggable";
//import { values } from "lodash";
import {
  Polyline,
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  Popup,
  Tooltip as TooltipMap,
} from "react-leaflet";

import L from "leaflet";
//import { isAsyncFunction } from 'util/types'
import "leaflet/dist/leaflet.css";

const Styles = styled.div`
  table {
    border-spacing: 0;
    border: 1px solid #c3c3c3;
    border-radius: 10px;
    border-collapse: initial;
    tr {
      border-radius: 0px;

      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #c3c3c3;
      border-right: 1px solid #c3c3c3;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

//
const GridStyles = styled.div`
  --rgt-background-color: ${(props) => props.themes.bg};
  textcolor: ${(props) => props.themes.fg};
  color: ${(props) => props.themes.fg};
  border: 2px solid ${(props) => props.themes.fg};
  background: ${(props) => props.themes.bg};
`;
const themes = {
  fg: "#BF4F74",
  bg: "black",
};

const defaultPropGetter = () => ({});

let AllPosition = [];

var columns2 = [];
var data2 = [];

var columns3 = [];
var data3 = [];

var columns12 = [];
var data12 = [];
var alldebtsuper = [];
var rows = [];

let n = 0;
let x = 0;
let y = 0;

let startposition = []; //50.380600, 30.453207 50.425051, 30.3631675];

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
//const theme = extendTheme({});

const Home = () => {
  const doctors_item = useSelector((state) => state.app.body.doctors_item);
  const auth = useContext(AuthContext);
  const current = useSelector((state) => state.app.current);
  const app = useSelector((state) => state.app);
  const body = useSelector((state) => state.app.body);
  const access = useSelector((state) => state.app.access.access);
  const UserSupervisors = access && access.user && access.user.supervisors;
  const UserSupervisorId =
    (UserSupervisors &&
      UserSupervisors[0] &&
      UserSupervisors[0].supervisor.id) ||
    "b68df4ab-7165-11e0-9097-002354cd8bde";
  const UserSupervisorname =
    (UserSupervisors &&
      UserSupervisors[0] &&
      UserSupervisors[0].supervisor.name) ||
    "Бабійчук Віктор Миколайович";
  const isadmin = (access && access.isadmin) || false;
  const allsupervisors = (access && access.allsupervisors) || false;
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [tab, setTab] = useState("1");

  const [SelectedDate, setSelectedDate] = useState(new Date()); //auth.Unitype || [])
  const [SelectedManager, setSelectedManager] = useState(null); //auth.Unitype || [])
  const [SelectedStore, setSelectedStore] = useState(); //auth.Unitype || [])

  const [SelectedDebtsManagers, setSelectedDebtsManagers] = useState();
  const [SelectedDebtsCustomers, setSelectedDebtsCustomers] = useState();
  const [SelectedDebtsStores, setSelectedDebtsStores] = useState(); //auth.Unitype || [])

  const [searchText, setSearchText] = useState();

  const [debts, setDebts] = useState(null);

  const [summapay, setSummapay] = useState(null);
  const [modalShow, setModalShow] = useState(false);

  // console.log("Refresh HOME!!!");
  const onGetLogTorg = (param, _Date) => {
    //if (!SelectedManager) return;
    let date1a = moment(_Date, "YYYY.MM.DD").format("YYYY.MM.DD") + " 06:00";
    let date2a = moment(_Date, "YYYY.MM.DD").format("YYYY.MM.DD") + " 20:00";
    let date1 = moment(date1a, "YYYY.MM.DD HH:mm").unix();
    let date2 = moment(date2a, "YYYY.MM.DD HH:mm").unix();
    if (param)
      dispatch({
        type: "FETCH_GETLOG",
        action: {
          ta_guid: param.id,
          date1: date1, //"1710412402",
          date2: date2, //"1710440402",
        },
      });
  };

  const clearAll = () => {
    setSelectedManager(null);
    setSelectedStore(null);

    dispatch({
      type: "fetch/get_add", //'fetch/get_add',
      payload: [],
      ob: "payments",
    });

    dispatch({
      type: "fetch/get_add", //'fetch/get_add',
      payload: [],
      ob: "debts",
    });
  };

  const handleSelectManager = (param) => {
    setSelectedStore(null);
    setSelectedManager(param);
    onGetLogTorg(param, SelectedDate);
  };

  const OnChangeTab1 = async function (value) {
    //console.log("OnChangeTab1 value", value);

    if (value === "1") {
      //setstartRefreshMaps(true);
      onGetLogTorg(SelectedManager, SelectedDate);
    } else if (value === "2") {
      setstartRefreshPayments(true);
    } else if (value === "1") {
      setstartRefreshDebts2(true);
    }
  };

  //Alert Dargable Dialog
  const [maxWidth, setmaxWidth] =
    React.useState("xs"); /*  "xs"  "sm"  "md"  "lg"  "xl"  */
  const [TitleAlertDialog, setTitleAlertDialog] = React.useState("");
  const [TextAlertDialog, setTextAlertDialog] = React.useState("");
  const [alertMessages, setAlertMessages] = useState([]);
  const [alertMessagesBorder, setAlertMessagesBorder] = useState(2);
  const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
  const [TypeAlertDialog, setTypeAlertDialog] =
    React.useState("ErrorDeleteTermin");

  const nameTheme = access && access.user && access.user.theme;
  const translate = useTranslate();
  const dispatch = useDispatch();

  let maxwidth = "65em";

  const handleAlertClose = () => {
    setTitleAlertDialog("");
    setTextAlertDialog("");
    setOpenAlertDialog(false);
  };

  //***************************************/

  //START get all str from table Roles
  //console.log('Refresh!!! customers...')

  const [startRefreshPayments, setstartRefreshPayments] = useState(true);
  const [startRefreshDebts2, setstartRefreshDebts2] = useState(true);

  //замыкание
  const ws_client = auth.ws_client; //body.ws_client

  const item_id = null; // = worker2 && worker2.value; //body.item_id

  const readonly = body.readonly;

  const GetData_handle = function (_result) {
    const { tableName, result, readonly, action } = _result;
    //console.log('result handle1 ', result
    if (
      tableName === "Payments" &&
      action &&
      action.metod &&
      action.metod === "getbySupervisor"
    ) {
      dispatch({
        type: "fetch/get_add", //'fetch/get_add',
        payload: result,
        ob: "payments",
      });
    }

    if (
      tableName === "Debts" &&
      action &&
      action.metod &&
      action.metod === "getbySupervisor"
    ) {
      dispatch({
        type: "fetch/get_add", //'fetch/get_add',
        payload: result,
        ob: "debtsuper",
      });
    }
  };

  const Refresh_handle = async function (result, event, parent) {
    const { tableName, action, metod } = result;
    /*console.log(
      'Refresh_handle ',
      event,
      new Date().toLocaleTimeString(),
      result
    )*/
    if (result && result.tableName) {
      let tableName = result.tableName;
      let metod = result.action && result.action.metod;
    }
  };

  const paramsPayments = {
    URL_WS: getURLAPI(auth.config, "URL_WS"), //get address WebSocket BK from config
    auth: { userId: auth.userId, tocken: auth.token },
    handleGetData: GetData_handle,
    handleChangeData: Refresh_handle,
    //handleSetRefresh: setStartRefresh,
    handleErrorRead: null,
    handleErrorChange: null,
    models: [
      {
        model_call_nm: "Model_read",
        tableName: "Payments",
        where: {},
        action: {
          metod: "getbySupervisor",
          //date: SelectedDate,
          supervisorid: UserSupervisorId,
        },
      },
    ],
  };

  const paramsDebts2 = {
    URL_WS: getURLAPI(auth.config, "URL_WS"), //get address WebSocket BK from config
    auth: { userId: auth.userId, tocken: auth.token },
    handleGetData: GetData_handle,
    handleChangeData: Refresh_handle,
    //handleSetRefresh: setStartRefresh,
    handleErrorRead: null,
    handleErrorChange: null,
    models: [
      {
        model_call_nm: "Model_read",
        tableName: "Debts",
        where: {},
        action: {
          metod: "getbySupervisor",
          supervisorid: UserSupervisorId,
        },
      },
    ],
  };

  //deblock item whet close page
  if (
    UserSupervisorId &&
    ws_client &&
    ws_client.ws_login &&
    startRefreshPayments
  ) {
    setstartRefreshPayments(false);
    ws_client.open_process(paramsPayments);
  }

  if (
    UserSupervisorId &&
    ws_client &&
    ws_client.ws_login &&
    startRefreshDebts2
  ) {
    console.log("setstartRefreshDebts2");
    setstartRefreshDebts2(false);
    ws_client.open_process(paramsDebts2);
  }

  //END get all str from table Roles

  //***************************************/

  columns3 = [
    {
      Header: "№",
      accessor: "num",
    },

    {
      Header: translate("resources.payments.fields.numnakl"), //'Тип работ',
      accessor: "numnakl",
    },
    {
      Header: translate("resources.payments.fields.datenakl"), //'Тип работ',
      accessor: "datenakl",
    },
    {
      Header: translate("resources.payments.fields.datepay"), //'Тип работ',
      accessor: "datepay",
    },
    {
      Header: translate("resources.payments.fields.paysumma"), //'Тип работ',
      accessor: "paysumma",
    },
    {
      Header: translate("resources.debts.fields.storename"), //'Тип работ',
      accessor: "storename",
    },
    {
      Header: translate("resources.debts.fields.customername"), //'Тип работ',
      accessor: "customername",
    },
  ];

  data3 = [];

  data2 = [];

  columns12 = [
    {
      Header: "№",
      accessor: "num",
    },

    {
      Header: translate("resources.debts.fields.numnakl"), //'Тип работ',
      accessor: "numnakl",
    },
    {
      Header: translate("resources.debts.fields.datenakl"), //'Тип работ',
      accessor: "datenakl",
    },
    /*
    {
      Header: translate("resources.order.fields.formpay"), //'Тип работ',
      accessor: "formpay",
    },
    {
      Header: translate("resources.order.fields.vidpay"), //'Тип работ',
      accessor: "vidpay",
    },
    /*    {
      Header: translate("resources.debts.fields.storename"), //'Тип работ',
      accessor: "storename",
    },*/

    {
      Header: translate("resources.debts.fields.paysumma"), //'Тип работ',
      accessor: "paysumma",
    },
    {
      Header: translate("resources.debts.fields.dolgsumma"), //'Тип работ',
      accessor: "dolgsumma",
    },
    {
      Header: translate("resources.debts.fields.delaydolgsumma"), //'Тип работ',
      accessor: "delaydolgsumma",
    },
    {
      Header: translate("resources.debts.fields.delaydays"), //'Тип работ',
      accessor: "delaydays",
    },
    {
      Header: translate("resources.debts.fields.managername"), //'Тип работ',
      accessor: "managername",
    },
    {
      Header: translate("resources.debts.fields.storename"), //'Тип работ',
      accessor: "storename",
    },
    {
      Header: translate("resources.debts.fields.customername"), //'Тип работ',
      accessor: "customername",
    },
  ];

  columns2 = [
    {
      id: 1,
      field: "num",
      label: "№",
      width: "70px",
      editable: false,
    },

    {
      id: 2,
      field: "numnakl",
      label: translate("resources.debts.fields.numnakl"),
      width: "140px",
      editable: false,
    },
    {
      id: 3,
      field: "datenakl",
      label: translate("resources.debts.fields.datenakl"),
      width: "120px",
      editable: false,
    },
    {
      id: 4,
      field: "paysumma",
      label: translate("resources.debts.fields.paysumma"),
      width: "190px",
      className: "",
      editable: true,
      //setValue: ({ value, data, setRow, column }) => {
      //  let rowClone = { ...data };
      //  rowClone[column.field].fieldToUpdate = value;
      //  setRow(rowClone);
      //},
      editorCellRenderer: ({
        tableManager,
        value,
        data,
        column,
        colIndex,
        rowIndex,
        onChange,
      }) => {
        return (
          <TextField
            //readOnly
            id="outlined-basic"
            label={"Введите сумму"}
            type="number"
            step="any"
            InputProps={{ inputProps: { min: 0, max: data.dolgsumma } }}
            //variant="standard"
            autoFocus={true}
            variant="outlined"
            style={{
              marginTop: -15,
              marginBottom: -15,
              height: 42,
              width: 320,
              backgroundColor: "#ffff0052",
              //display: "flex",
              //justifyContent: "space-between",
              //"&:hover": {
              //  backgroundColor: "yellow", //"primary.light",
              //backgroundColor: 'primary.dark',
              //  opacity: [0.9, 0.8, 0.7],
              //},
            }}
            //defaultValue={viewtValue || ''} //field && field[name] && field[name].name}
            value={value || ""} //field && field[name] && field[name].name}
            //disabled={disabled || false}
            onChange={(e) =>
              onChange({ ...data, [column.field]: e.target.value })
            }
            // onFocus={(e) => (e.target.readOnly = true)} //выключение клавиатуры при выборе значения
          />
        );
      },
    },
    {
      id: "my-buttons-column",
      //width: "max-content",
      width: "120px",
      pinned: true,
      sortable: false,
      resizable: false,
      cellRenderer: ({
        tableManager,
        value,
        data,
        column,
        colIndex,
        rowIndex,
      }) => {
        return (
          <button
            style={{ marginLeft: 20 }}
            onClick={(e) => {
              //setDebts(data);
              //if(!data.paysumma)
              tableManager.rowEditApi.setEditRowId(data.id);
              //let client = data;
              //setValue("client", client);

              /*
            let Messages = [];
            Messages.push({
              num: 1,
              msg: "Накладная - " + data.numnakl,
            });
            Messages.push({
              num: 2,
              msg: "Дата накладной - " + data.datenakl,
            });

            Messages.push({
              num: 3,
              msg: "Сумма долга - " + data.dolgsumma,
            });

            setmaxWidth("lg");
            //setAlertMessagesBorder("4px solid #ee2f00a8");
            setTitleAlertDialog(translate("resources.home.debtspays"));
            setAlertMessages(Messages);
            setTypeAlertDialog("Debts");
            //setTextAlertDialog("Введите платеж");
            setOpenAlertDialog(true);
*/
              //setstartRefreshChats(true);
              //setstartRefreshTermins(true);
              //setOpenSearch(false);
              //setCustomer2({
              //  label: client.name + " " + client.surname,
              //  value: client.id,
              //});
            }}
            type="button"
          >
            &#x270E;
          </button>
        );
      },

      editorCellRenderer: ({
        tableManager,
        value,
        data,
        column,
        colIndex,
        rowIndex,
        onChange,
      }) => {
        return (
          <div style={{ display: "inline-flex" }}>
            <button
              style={{ marginLeft: 20 }}
              onClick={(e) => {
                tableManager.rowEditApi.setEditRowId(null);
              }}
              type="button"
            >
              &#x2716;
            </button>
            <button
              style={{ marginLeft: 10, marginRight: 20 }}
              onClick={async (e) => {
                let rowsClone = [...rows];
                let updatedRowIndex = rowsClone.findIndex(
                  (r) => r.id === data.id
                );
                rowsClone[updatedRowIndex] = data;

                try {
                  //записать изменения
                  //let pbxitem = checkSIPConfig(pbx_item);

                  const pay = {
                    numnakl: data.numnakl,
                    datenakl: moment(data.datenakl, "DD.MM.YYYY").format(
                      "YYYY-MM-DD"
                    ),
                    //naklid?: string,
                    paysumma: data.paysumma,
                    //datepay: data.,
                    storeid: data.storeid,
                    customerid: data.customerid,
                    managerid: null,
                    supervisorid: UserSupervisorId,
                    debtid: data.id,
                  };

                  await ws_client.wss_setItem({
                    tableName: "Payments",
                    item: pay, //pbx_item,
                    call_nm: "Model_update",
                    where: null,
                    action: { metod: "savePay" },
                    callback: () => {
                      setstartRefreshDebts2(true);
                    },
                  });
                } catch (e) {
                  console.log("eror e", e);
                }

                //setRowsData(rowsClone);
                tableManager.rowEditApi.setEditRowId(null);
              }}
              type="button"
            >
              &#x2714;
            </button>
          </div>
        );
      },
    },
    {
      id: 5,
      field: "dolgsumma",
      label: translate("resources.debts.fields.dolgsumma"),
      width: "130px",
    },
    {
      id: 6,
      field: "delaydolgsumma",
      label: translate("resources.debts.fields.delaydolgsumma"),
      width: "130px",
    },
    {
      id: 7,
      field: "delaydays",
      label: translate("resources.debts.fields.delaydays"),
      width: "130px",
    },
    {
      id: 8,
      field: "managername",
      label: translate("resources.debts.fields.managername"),
      width: "280px",
    },
    {
      id: 9,
      field: "storename",
      label: translate("resources.debts.fields.storename"),
      width: "280px",
    },
    {
      id: 10,
      field: "customername",
      label: translate("resources.debts.fields.customername"),
      width: "280px",
    },
  ];

  data12 = [];
  alldebtsuper = [];

  let num12 = 1;

  let debtsManagers = [];
  let debtsCustomers = [];
  let debtsStores = [];

  const changedebtsManagers = (event, value) => {
    //    clearAll();
    setSelectedDebtsManagers(value);
    setSelectedDebtsCustomers(null);
    setSelectedDebtsStores(null);
  };

  const changedebtsCustomers = (event, value) => {
    //    clearAll();
    setSelectedDebtsCustomers(value);
    setSelectedDebtsStores(null);
    //setSelectedDebtsManagers(null);
  };

  const changedebtsStores = (event, value) => {
    //    clearAll();
    setSelectedDebtsStores(value);
  };

  let debtsuper = body.debtsuper || null;
  if (debtsuper && debtsuper.length > 0) {
    for (let d in debtsuper) {
      //summaDemtsAllDolg = summaDemtsAllDolg + Number(Debts[d].dolgsumma);
      //summaDemtsAllDolgdelay =
      //  summaDemtsAllDolgdelay + Number(Debts[d].delaydolgsumma);
      data12.push({
        num: num12++,
        id: debtsuper[d].id,
        item: debtsuper[d],
        numnakl: debtsuper[d].numnakl,
        datenakl: moment(debtsuper[d].datenakl, "YYYY-MM-DD").format(
          "DD.MM.YYYY"
        ),
        managerid: debtsuper[d].stores && debtsuper[d].managers.id,
        managername: debtsuper[d].stores && debtsuper[d].managers.name,
        storename: debtsuper[d].stores && debtsuper[d].stores.name,
        storeid: debtsuper[d].stores && debtsuper[d].stores.id,
        customername: debtsuper[d].customers && debtsuper[d].customers.name,
        customerid: debtsuper[d].customers && debtsuper[d].customers.id,
        dolgsumma: debtsuper[d].dolgsumma,
        delaydays: debtsuper[d].delaydays,
        delaydolgsumma: debtsuper[d].delaydolgsumma,
        formpay: debtsuper[d].formpays && debtsuper[d].formpays.name,
        vidpay: debtsuper[d].vidpays && debtsuper[d].vidpays.name,
        paysumma:
          (debtsuper[d].debts &&
            debtsuper[d].debts.length > 0 &&
            //debtsuper[d].debts[0].datepay +
            //  " " +
            debtsuper[d].debts[0].paysumma) ||
          "",
      });
      alldebtsuper.push({
        managerid: debtsuper[d].stores && debtsuper[d].managers.id,
        managername: debtsuper[d].stores && debtsuper[d].managers.name,
        storename: debtsuper[d].stores && debtsuper[d].stores.name,
        storeid: debtsuper[d].stores && debtsuper[d].stores.id,
        customername: debtsuper[d].customers && debtsuper[d].customers.name,
        customerid: debtsuper[d].customers && debtsuper[d].customers.id,
      });
    }

    //  data12.push({
    //      datenakl: "Итого:",
    //      dolgsumma: summaDemtsAllDolg.toFixed(2),
    //      delaydolgsumma: summaDemtsAllDolgdelay.toFixed(2),
    //    });
  }

  debtsManagers = useMemo(() => {
    let _debtsManagers = [];
    let DebtsManagers = [];
    for (let d1 in alldebtsuper) {
      let ifexists = DebtsManagers.find(
        (element) => element.id === alldebtsuper[d1].managerid
      );
      if (ifexists === undefined)
        DebtsManagers.push({
          id: alldebtsuper[d1].managerid,
          name: alldebtsuper[d1].managername,
        });
    }
    for (var d in DebtsManagers) {
      _debtsManagers.push({
        label: DebtsManagers[d].name,
        value: DebtsManagers[d].id,
      });
    }

    return _debtsManagers;
  }, [data12]);

  debtsStores = useMemo(() => {
    let _debtsStores = [];
    let DebtsStores = [];
    for (let d1 in alldebtsuper) {
      let ifexists = DebtsStores.find(
        (element) => element.id === alldebtsuper[d1].storeid
      );
      if (
        ifexists === undefined &&
        alldebtsuper[d1].customerid &&
        (alldebtsuper[d1].customerid === SelectedDebtsCustomers?.value ||
          SelectedDebtsCustomers?.value === undefined)
      )
        DebtsStores.push({
          id: alldebtsuper[d1].storeid,
          name: alldebtsuper[d1].storename,
          customerid: alldebtsuper[d1].customerid,
        });
    }
    for (var d in DebtsStores) {
      _debtsStores.push({
        label: DebtsStores[d].name,
        value: DebtsStores[d].id,
      });
    }

    return _debtsStores;
  }, [SelectedDebtsCustomers?.value]);

  debtsCustomers = useMemo(() => {
    let _debtsCustomers = [];
    let DebtsCustomers = [];
    for (let d1 in alldebtsuper) {
      let ifexists = DebtsCustomers.find(
        (element) => element.id === alldebtsuper[d1].customerid
      );
      if (
        ifexists === undefined &&
        alldebtsuper[d1].customerid &&
        alldebtsuper[d1].managerid &&
        (alldebtsuper[d1].managerid === SelectedDebtsManagers?.value ||
          SelectedDebtsManagers?.value === undefined)
      )
        DebtsCustomers.push({
          id: alldebtsuper[d1].customerid,
          name: alldebtsuper[d1].customername,
        });
    }
    for (var d in DebtsCustomers) {
      _debtsCustomers.push({
        label: DebtsCustomers[d].name,
        value: DebtsCustomers[d].id,
      });
    }

    return _debtsCustomers;
  }, [alldebtsuper]);

  if (data12 && SelectedDebtsCustomers?.value !== undefined) {
    data12 = data12.filter((item) => {
      //      console.log('item', item)
      //      console.log('item.name', item.name)
      return item.customerid === SelectedDebtsCustomers.value;
    });
  }

  if (data12 && SelectedDebtsStores?.value !== undefined) {
    data12 = data12.filter((item) => {
      //      console.log('item', item)
      //      console.log('item.name', item.name)
      return item.storeid === SelectedDebtsStores.value;
    });
  }

  if (data12 && SelectedDebtsManagers?.value !== undefined) {
    data12 = data12.filter((item) => {
      //      console.log('item', item)
      //      console.log('item.name', item.name)
      return item.managerid === SelectedDebtsManagers.value;
    });
  }

  let count = 1;
  for (let l in data12) {
    data12[l].num = count++;
  }

  rows = data12;
  let Getlog = body.getlog;
  AllPosition = useMemo(() => {
    let _AllPosition = [];
    x = 0;
    y = 0;
    n = 0;
    for (let g in Getlog) {
      n++;
      x = x + Getlog[g].x;
      y = y + Getlog[g].y;
      _AllPosition.push([
        Getlog[g].x, //50.557668,
        Getlog[g].y, //30.255422
      ]);
    }
    if (n > 0) {
      x = x / n;
      y = y / n;
      startposition = [x, y];
    }
    return _AllPosition;
  }, [Getlog]);

  const arrayfindid = (array, value) => {
    const found = array.find((element) => element.id === value);
    return found;
  };

  let inforoutesheets = body.routesheets;
  let Routesheets = inforoutesheets && inforoutesheets.routesheets; //body.routesheets;
  let AddStores = inforoutesheets && inforoutesheets.addstores; //body.routesheets;
  let Infostores = inforoutesheets && inforoutesheets.infostores; //body.routesheets;

  let routesheets = useMemo(() => {
    let _routesheets = [];
    if (Routesheets && Routesheets[0] && Routesheets[0].items) {
      let items = Routesheets[0].items;
      for (let r in items) {
        _routesheets.push({
          id: items[r].storeid,
          num: items[r].num,
          name: items[r].stores.name,
          longitude: items[r].stores.longitude,
          latitude: items[r].stores.latitude,
          typepriceid: items[r].stores.typepriceid,
          addstore: false,
          sumpays: 0,
          sumorders: 0,
          dolgsumma: 0,
          delaydolgsumma: 0,
          customer:
            items[r].stores.itemcustomers &&
            items[r].stores.itemcustomers.items,
        });
      }
    }
    if (AddStores && AddStores.length > 0) {
      for (let a in AddStores) {
        let isExists = _routesheets.find((item) => {
          return item.id === AddStores[a].id;
        });
        if (!isExists)
          _routesheets.push({
            id: AddStores[a].id,
            num: "",
            name: AddStores[a].name,
            longitude: AddStores[a].longitude,
            latitude: AddStores[a].latitude,
            typepriceid: AddStores[a].typepriceid,
            addstore: true,
            sumpays: 0,
            sumorders: 0,
            dolgsumma: 0,
            delaydolgsumma: 0,
            customer:
              AddStores[a].itemcustomers && AddStores[a].itemcustomers.items,
          });
      }
    }

    let row;

    for (let r2 in _routesheets) {
      row = arrayfindid(Infostores, _routesheets[r2].id);
      if (row) {
        _routesheets[r2].sumpays = row.sumpays.toFixed(2);
        _routesheets[r2].sumorders = row.sumorders.toFixed(2);
        _routesheets[r2].dolgsumma = row.dolgsumma.toFixed(2);
        _routesheets[r2].delaydolgsumma = row.delaydolgsumma.toFixed(2);
      }
    }

    return _routesheets;
  }, [Routesheets, AddStores]);

  let summaDemtsAllDolg = 0;
  let summaDemtsAllDolgdelay = 0;

  let num2 = 1;
  let Debts = body.debts || null;
  if (Debts && Debts.length > 0) {
    for (let d in Debts) {
      summaDemtsAllDolg = summaDemtsAllDolg + Number(Debts[d].dolgsumma);
      summaDemtsAllDolgdelay =
        summaDemtsAllDolgdelay + Number(Debts[d].delaydolgsumma);
      data2.push({
        num: num2++,
        numnakl: Debts[d].numnakl,
        datenakl: moment(Debts[d].datenakl, "YYYY-MM-DD").format("DD.MM.YYYY"),
        storename: Debts[d].stores && Debts[d].stores.name,
        customername: Debts[d].customers && Debts[d].customers.name,
        dolgsumma: Debts[d].dolgsumma,
        delaydays: Debts[d].delaydays,
        delaydolgsumma: Debts[d].delaydolgsumma,
        formpay: Debts[d].formpays && Debts[d].formpays.name,
        vidpay: Debts[d].vidpays && Debts[d].vidpays.name,
      });
    }
    data2.push({
      datenakl: "Итого:",
      dolgsumma: summaDemtsAllDolg.toFixed(2),
      delaydolgsumma: summaDemtsAllDolgdelay.toFixed(2),
    });
  }

  let Payments = body.payments || null;

  let SummaAll = 0;
  let num3 = 0;
  if (Payments && Payments.length > 0) {
    for (let p in Payments) {
      let items = Payments[p];
      num3++;
      SummaAll = SummaAll + Number(items.paysumma);
      data3.push({
        num: num3,
        numnakl: items.numnakl,
        datenakl: moment(items.datenakl, "YYYY-MM-DD").format("DD.MM.YYYY"),
        datepay: moment(items.datepay, "YYYY-MM-DD").format("DD.MM.YYYY"),
        storename: items.stores && items.stores.name,
        customername:
          items.stores &&
          items.stores.itemcustomers &&
          items.stores.itemcustomers.items?.name,
        paysumma: items.paysumma,
      });
    }
    data3.push({
      numnakl: "",
      datenakl: "Итого: ",
      storename: " ",
      paysumma: SummaAll.toFixed(2),
    });
  }

  //          body.managers.map((Item) => <ItemList Item={Item} />)}
  function Table1({
    columns,
    data,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getRowProps = defaultPropGetter,
    getCellProps = defaultPropGetter,
  }) {
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  // Return an array of prop objects and react-table will merge them appropriately
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                      style: column.style,
                    },
                    getColumnProps(column),

                    getHeaderProps(column),
                  ])}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              // Merge user row props in
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      // Return an array of prop objects and react-table will merge them appropriately
                      {...cell.getCellProps([
                        {
                          className: cell.column.className,
                          style: cell.column.style,
                        },
                        getColumnProps(cell.column),
                        //  getCellProps(cell),
                      ])}
                      align="center"
                      //                    width="140px"
                    >
                      {(cell.column.id !== "timeline" && (
                        <Button
                          //as={Link}
                          variant="outline-primary"
                          style={{
                            backgroundColor:
                              cell.row.original.manager.id ===
                              (SelectedManager && SelectedManager.id)
                                ? "#00ff2369"
                                : "",
                          }}
                          //style={{ marginBottom: 5 }}

                          //to={{
                          //  pathname: "/pages/manager/item",
                          //}}
                          //state={{
                          //  id: cell.row.original.manager.id, //cell.row.original['worktime_id'],
                          //}}
                          onClick={() => {
                            handleSelectManager({
                              id: cell.row.original.manager.id,
                              name: cell.row.original.manager.name,
                            });
                            /*
                            dispatch({
                              type: "fetch/get", //_add',
                              payload: cell.row.original.manager.id,
                              ob: "item_id",
                            });
                            */
                          }}
                        >
                          {cell.render("Cell")}
                        </Button>
                      )) ||
                        cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  function Table2({
    columns,
    data,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getRowProps = defaultPropGetter,
    getCellProps = defaultPropGetter,
  }) {
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  // Return an array of prop objects and react-table will merge them appropriately
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                      style: column.style,
                    },
                    getColumnProps(column),

                    getHeaderProps(column),
                  ])}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              // Merge user row props in
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      // Return an array of prop objects and react-table will merge them appropriately
                      {...cell.getCellProps([
                        {
                          className: cell.column.className,
                          style: cell.column.style,
                        },
                        getColumnProps(cell.column),
                        //  getCellProps(cell),
                      ])}
                      align="center"
                      //                    width="140px"
                    >
                      {(cell.column.id !== "num" && (
                        <Button
                          //as={Link}
                          variant="outline-primary"
                          //to={{
                          //  pathname: "/pages/manager/item",
                          //}}
                          //state={{
                          //  id: cell.row.original.manager.id, //cell.row.original['worktime_id'],
                          //}}
                          onClick={() => {
                            //handleSelectedStore({
                            //  id: cell.row.original.store.id,
                            //  name: cell.row.original.store.name,
                            //});
                            /*
                            dispatch({
                              type: "fetch/get", //_add',
                              payload: cell.row.original.manager.id,
                              ob: "item_id",
                            });
                            */
                          }}
                        >
                          {cell.render("Cell")}
                        </Button>
                      )) ||
                        cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  //Выполнение Планов на менеджеров
  function Table_PD({
    columns,
    data,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getRowProps = defaultPropGetter,
    getCellProps = defaultPropGetter,
  }) {
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  // Return an array of prop objects and react-table will merge them appropriately
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                      style: column.style,
                    },
                    getColumnProps(column),

                    getHeaderProps(column),
                  ])}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              // Merge user row props in
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  let v = cell.row.original;
                  let Checked = false;
                  if (v && v.isfinished) {
                    Checked = true;
                  }
                  return (
                    <td
                      // Return an array of prop objects and react-table will merge them appropriately
                      {...cell.getCellProps([
                        {
                          className: cell.column.className,
                          style: cell.column.style,
                        },
                        getColumnProps(cell.column),
                        //  getCellProps(cell),
                      ])}
                      align="center"
                      //                    width="140px"
                    >
                      {cell.column.id === "isfinished" && (
                        <>
                          <FormControlLabel
                            style={{
                              marginRight: 15,
                              marginLeft: 10,
                            }}
                            control={
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={Checked}
                                disabled={readonly}
                                /*                    <Switch
                                id={1}
                                name={'DopInfo'}*/
                                color="primary"
                                //                              onChange={handleChangeSwitch}
                                onChange={async (item) => {
                                  if (!readonly) {
                                    try {
                                      /*
                                      await ws_client.wss_setItem({
                                        tableName: "Roles",
                                        item: role_item,
                                        call_nm: "Model_update",
                                        where: {
                                          checked: Checked,
                                          unit_id: v.unit_id,
                                          //roleunit_id: v.roleunit_id,
                                        },
                                        action: {
                                          metod: "setroleunits",
                                        },
                                        callback: setRoles,
                                      });
                                      */
                                    } catch (e) {
                                      console.log("errr e", e);
                                    }
                                  }
                                }}
                              />
                            }
                            label={""}
                          />
                        </>
                      )}

                      {cell.column.id !== "isfinished" && cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  let language = "ru";
  if (access && access.user && access.user.language) {
    if (access.user.language === "ru") language = "ru";
    if (access.user.language === "ua") language = "uk";
    if (access.user.language === "en") language = "en";
    if (access.user.language === "de") language = "de";
  }

  moment.locale(language); //'ua')
  //const localizer = momentLocalizer(moment);

  const ref = React.useRef(null);

  //  useHotkeys("f5", () => ref.current && ref.current.focus());

  const ready = () => {
    if (doctors_item /* && calendars*/ || true)
      // || !(worker2 && worker2.value))
      return true;
    else return false;
  };

  function DContent(props) {
    const {
      bgColor,
      color,
      labelIcon: LabelIcon,
      labelInfo,
      labelText,
      Id,
      parentId,
      level,
      ...other
    } = props;
    return (
      <>
        {TypeAlertDialog === "ErroDeleteTermin" && (
          <RadioGroup
            row
            //{...register("termin.alertdelete", { type: "radio" })}
            style={{
              marginLeft: 50,
            }}
            //onChange={RhandleChangelanguage}
          >
            <FormControlLabel
              value="DELETE"
              control={<Radio />}
              label={translate("resources.home.alertdelete")}
            />
            <FormControlLabel
              value="CREATE"
              control={<Radio />}
              label={translate("resources.home.alertcreate")}
            />
            <FormControlLabel
              value="NOT"
              control={<Radio />}
              label={translate("resources.home.alertnotdelete")}
            />
          </RadioGroup>
        )}
        {TypeAlertDialog === "MoveTermin" && <> </>}
      </>
    );
  }

  function DContext(props) {
    const {
      bgColor,
      color,
      labelIcon: LabelIcon,
      labelInfo,
      labelText,
      Id,
      parentId,
      level,
      ...other
    } = props;
    return (
      <>
        {TypeAlertDialog === "Debts" && TextAlertDialog}
        {TypeAlertDialog === "Debts" && (
          <>
            <FormControl fullWidth sx={{ m: 1 }}>
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableBody
                    sx={{
                      border: alertMessagesBorder ? alertMessagesBorder : 2,
                    }}
                  >
                    {alertMessages.map((row) => (
                      <TableRow
                        key={row.num}
                        sx={{
                          border: row.border ? row.border : 0,
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        {/*                        <TableCell align="right" sx={{ width: 30 }}>
                          {row.num}
                        </TableCell>
                      */}
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            fontSize: "1.60rem",
                            color: row.color ? row.color : "",
                            backgroundColor: row.bkcolor ? row.bkcolor : "",
                          }}
                        >
                          {row.msg}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TextField
                //{...params}
                clearable
                style={{ marginTop: 30 }}
                label={translate("resources.debts.inputpay")} //""Выберите супервайзера" //Выберите Тип доступа"
                variant="outlined"
                value={summapay || ""}
                onChange={(item) => {
                  let value = item.target.value;
                  setSummapay(value);
                  //setValue("client.search", value);
                  if (value && value.length >= 4) {
                    //setOpenSearch(true);
                  } else {
                    //setOpenSearch(false);
                  }
                }}

                //variant="standard"
                //          placeholder="Выберите Мастера"
              />
            </FormControl>
          </>
        )}
      </>
    );
  }

  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  function AlertDialog(props) {
    return (
      <>
        {/* Alert Dialog */}
        <Dialog
          open={openAlertDialog}
          maxWidth={maxWidth}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          onClose={handleAlertClose}
          PaperProps={{
            component: "form",
            onSubmit: async (event) => {
              event.preventDefault();
              //const formData = new FormData(event.currentTarget);
              //const formJson = Object.fromEntries(formData.entries());

              if (TypeAlertDialog === "ErroDeleteTermin") {
                //WhenErrorDeleteTermin();
              }
              handleAlertClose();
            },
          }}
        >
          <DialogTitle
            style={{
              fontSize: "1.60rem",
            }}
          >
            {TitleAlertDialog}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <DContext />
            </DialogContentText>
            <DContent />
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                ml: 1,
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "primary.light",
                  //backgroundColor: 'primary.dark',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              variant="contained"
              onClick={handleAlertClose}
            >
              Cancel
            </Button>
            <Button
              sx={{
                ml: 1,
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "primary.light",
                  //backgroundColor: 'primary.dark',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              variant="contained"
              type="submit"
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  function ModaltDialog(props) {
    return (
      <>
        {/* Alert Dialog */}
        {/*<Dialog >*/}
        <Modal
          show={openAlertDialog}
          onHide={() => setOpenAlertDialog(false)}
          //size="lg"
          style={{
            display: "inline-flex",
            //     height: 36,
            margin: "1.75rem auto",
            //width: isXSmall ? 380 : 580,
            //          marginTop: 2,
            //marginBottom: 1,
            //          align: 'center',
            //alignItems: 'center',
          }}
          aria-labelledby={`contained-modal-name-vcenter`}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id={`contained-modal-name-vcenter`}>
              {"title"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TextField
              id="outlined-basic"
              label={translate("resources.allselect.search")} //""Введите поисковый запрос"
              //variant="standard"
              variant="outlined"
              style={{
                width: isXSmall ? 300 : 460,
                marginBottom: 15,
                //              display: 'flex',
                //            justifyContent: 'space-between',
              }}
              //defaultValue={filter}
              //value={filter}
              //onChange={(item) => setFilter(item.target.value)}
            />
            <TextField
              //{...params}
              //clearable
              style={{ marginTop: 30 }}
              label={translate("resources.debts.inputpay")} //""Выберите супервайзера" //Выберите Тип доступа"
              variant="outlined"
              value={summapay || ""}
              onChange={(item) => {
                let value = item.target.value;
                setSummapay(value);
                //setValue("client.search", value);
                if (value && value.length >= 4) {
                  //setOpenSearch(true);
                } else {
                  //setOpenSearch(false);
                }
              }}

              //variant="standard"
              //          placeholder="Выберите Мастера"
            />

            {isadmin && (
              <>
                <div
                  //            className="hstack gap-2"
                  style={{
                    marginTop: -20,
                    marginBottom: 15,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    //size="small"
                    color="primary"
                    variant="outlined"
                    sx={{
                      display: "inline-flex",
                      height: 36,
                      marginTop: 2,
                      marginBottom: 1,
                      alignItems: "center",
                    }}
                    //              sx={{ display: 'inline-flex', alignItems: 'center' }}
                    //disabled={
                    //                      new_customer_name === '' || new_customer_tel1 === ''
                    //                    } // getDisabled()}
                    onClick={(req, res) => {
                      //                            const customer = cell.row.original.customer
                      //                      console.log(new_customer_name, new_customer_tel1)
                      //setFilter(new_customer_tel1)
                      /*
                      dispatch({
                        type: 'FETCH_NEWCUSTOMER',
                        urlapi: URLAPI,
                        arg: {
                          name: new_customer_name,
                          tel1: new_customer_tel1,
                        },
                        ob: 'customers',
                        //    time1: worktime_item.time1,
                        //    time2: worktime_item.time1,
                        //        workerid: worktime_item.workerid,
                        // },
                      })

                      dispatch({ type: 'FETCH_LIST', urlapi: URLAPI, ob: name })
                      /*
                            dispatch({
                              type: 'app/set',
                              payload: {
                                id: field,
                                field: `${name}id`,
                                value: customer,
                                ob: name,
                              },
                              ob: value,
                            })
*/
                    }} //onClickCell(cellInfo, req, res),
                    //                        onClick
                  >
                    Создать
                  </Button>
                </div>
                <div
                  //            className="hstack gap-2"
                  style={{
                    marginTop: -20,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label={translate("resources.customers.fields.name")} //"Имя"
                    //variant="standard"
                    variant="outlined"
                    style={{
                      width: isXSmall ? 150 : 180,
                      marginBottom: 15,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    //value={new_customer_name}
                    //                  defaultValue={filter}
                    //            onChange={(item) => setFilter(item.target.value)}
                    onChange={(item) => {
                      //                    worktime_item.change = true
                      //setnew_customer_name(item.target.value)

                      dispatch({
                        type: "app/set",
                        payload: {
                          //                      id: worktime_item,
                          field: "new_customer_name",
                          value: item.target.value,
                        },
                        ob: "worktime_item",
                      });
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    label={translate("resources.customers.fields.phone")} //"Телефон 1"
                    //variant="standard"
                    variant="outlined"
                    style={{
                      width: isXSmall ? 150 : 180,
                      marginBottom: 15,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    //value={new_customer_tel1}
                    //defaultValue={filter}
                    //            onChange={(item) => setFilter(item.target.value)}
                    //onChange={(item) => {
                    //                    worktime_item.change = true
                    //setnew_customer_tel1(item.target.value)
                    //if (item.target.value.length >= 10)
                    //setFilter(item.target.value)
                    /*                    dispatch({
                      type: 'app/set',
                      payload: {
                        //                      id: worktime_item,
                        field: 'new_customer_tel1',
                        value: item.target.value,
                      },
                      ob: 'worktime_item',
                    })
                    */
                    //}}
                  />
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      </>
    );
  }

  const main = (
    <>
      {ready() && (
        <>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: !isXSmall ? "row" : "column",
                flexWrap: !isXSmall ? "wrap" : "",
                marginTop: -3,
                justifyContent: !isXSmall ? "space-between" : "",
              }}
            >
              <Box
                style={{
                  width: !isXSmall ? "100%" : "100%",
                  height: !isXSmall ? "100%" : "44%",
                  //marginBottom: 60,
                }}
              >
                <TabContext value={tab} sx={{ p: 0 }}>
                  <Box sx={{ borderBottom: 0, borderColor: "divider", p: 0 }}>
                    <TabList
                      onChange={(_, value) => {
                        OnChangeTab1(value);
                        setTab(value);
                      }}
                      variant="scrollable"
                      aria-label="lab API tabs example"
                    >
                      <Tab
                        label={translate("resources.home.debtspays")}
                        style={
                          (data2 && data2.length) > 0
                            ? { color: "green", fontWeight: "bold" }
                            : {}
                        }
                        value="1"
                      />
                      <Tab
                        label={translate("resources.home.payments")}
                        style={
                          (data3 && data3.length) > 0
                            ? { color: "green", fontWeight: "bold" }
                            : {}
                        }
                        value="2"
                      />
                    </TabList>
                  </Box>
                  <TabPanel value="1" sx={{ p: 0 }}>
                    <div
                      style={{ marginTop: 0, height: !isXSmall ? 640 : 600 }}
                    >
                      {
                        <Box>
                          <Card
                            sx={{
                              minWidth: 275,
                              height: !isXSmall ? 680 : 400,
                            }}
                          >
                            <CardContent style={{ padding: 0 }}>
                              <div
                                //            className="hstack gap-2"
                                style={{
                                  marginTop: 10,
                                  display: "flex",
                                  height: "100%",

                                  //justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  id="outlined-basic"
                                  label="Клиент"
                                  //variant="standard"
                                  className="title h6"
                                  style={{
                                    marginTop: 0,
                                    marginBottom: 15,
                                    marginRight: 40,
                                    //display: 'flex',
                                    //justifyContent: 'space-between',
                                  }}
                                >
                                  {UserSupervisorname}
                                  {/*translate("resources.home.filter") + " :"*/}
                                </Typography>
                                <div
                                  style={{
                                    width: 1020,
                                    marginTop: 0,
                                    //marginBottom: 15,
                                    marginRight: 40,
                                    display: "flex",
                                    //justifyContent: 'space-between',
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 480,
                                      marginTop: -16,
                                      //marginBottom: 15,
                                      marginRight: 40,
                                      //display: "flex",
                                      //justifyContent: 'space-between',
                                    }}
                                  >
                                    <Autocomplete
                                      //multiple
                                      id="size-small-outlined1" //      id="checkboxes-tags"
                                      options={debtsManagers}
                                      onChange={changedebtsManagers}
                                      size="small"
                                      value={SelectedDebtsManagers || null}
                                      //                defaultValue={(worker2 && worker2[0]) || []}
                                      //limitTags={4}
                                      //              filterSelectedOptions
                                      isOptionEqualToValue={(props, option) => {
                                        let rez = false;
                                        if (props.value === option.value)
                                          rez = true;
                                        return rez;
                                      }}
                                      selectOnFocus
                                      clearOnBlur
                                      onFocus={(e) => {
                                        //            console.log(e.target.readOnly)
                                        return (e.target.readOnly = true);
                                      }} //выключение клавиатуры при выборе      handleHomeEndKeys
                                      //      disableCloseOnSelect
                                      getOptionLabel={(option) => option.label}
                                      renderOption={(
                                        props,
                                        option,
                                        { selected }
                                      ) => {
                                        return (
                                          <li {...props}>
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selected}
                                            />
                                            {option.label}
                                          </li>
                                        );
                                      }}
                                      style={{ width: "100%" }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={translate(
                                            "resources.home.selectmanager"
                                          )} //""Выберите супервайзера" //Выберите Тип доступа"
                                          variant="outlined"
                                          //          variant="standard"
                                          //          placeholder="Выберите Мастера"
                                        />
                                      )}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      width: 480,
                                      marginTop: -16,
                                      //marginBottom: 15,
                                      marginRight: 40,
                                      //display: "flex",
                                      //justifyContent: 'space-between',
                                    }}
                                  >
                                    <Autocomplete
                                      //multiple
                                      id="size-small-outlined" //      id="checkboxes-tags"
                                      options={debtsCustomers}
                                      onChange={changedebtsCustomers}
                                      size="small"
                                      value={SelectedDebtsCustomers || null}
                                      //defaultValue={SelectedDebtsCustomers}
                                      //limitTags={4}
                                      //              filterSelectedOptions
                                      isOptionEqualToValue={(props, option) => {
                                        let rez = false;
                                        if (props.value === option.value)
                                          rez = true;
                                        return rez;
                                      }}
                                      selectOnFocus
                                      clearOnBlur
                                      onFocus={(e) => {
                                        //            console.log(e.target.readOnly)
                                        return (e.target.readOnly = true);
                                      }} //выключение клавиатуры при выборе      handleHomeEndKeys
                                      //      disableCloseOnSelect
                                      getOptionLabel={(option) => option.label}
                                      renderOption={(
                                        props,
                                        option,
                                        { selected }
                                      ) => {
                                        return (
                                          <li {...props}>
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selected}
                                            />
                                            {option.label}
                                          </li>
                                        );
                                      }}
                                      style={{ width: "100%" }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={translate(
                                            "resources.home.selectcustomer"
                                          )} //""Выберите супервайзера" //Выберите Тип доступа"
                                          variant="outlined"
                                          //          variant="standard"
                                          //          placeholder="Выберите Мастера"
                                        />
                                      )}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      width: 480,
                                      marginTop: -16,
                                      //marginBottom: 15,
                                      marginRight: 40,
                                      //display: "flex",
                                      //justifyContent: 'space-between',
                                    }}
                                  >
                                    <Autocomplete
                                      //multiple
                                      id="size-small-outlined" //      id="checkboxes-tags"
                                      options={debtsStores}
                                      onChange={changedebtsStores}
                                      size="small"
                                      value={SelectedDebtsStores || null}
                                      //                defaultValue={(worker2 && worker2[0]) || []}
                                      limitTags={4}
                                      //              filterSelectedOptions
                                      isOptionEqualToValue={(props, option) => {
                                        let rez = false;
                                        if (props.value === option.value)
                                          rez = true;
                                        return rez;
                                      }}
                                      selectOnFocus
                                      clearOnBlur
                                      onFocus={(e) => {
                                        //            console.log(e.target.readOnly)
                                        return (e.target.readOnly = true);
                                      }} //выключение клавиатуры при выборе      handleHomeEndKeys
                                      //      disableCloseOnSelect
                                      getOptionLabel={(option) => option.label}
                                      renderOption={(
                                        props,
                                        option,
                                        { selected }
                                      ) => {
                                        return (
                                          <li {...props}>
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selected}
                                            />
                                            {option.label}
                                          </li>
                                        );
                                      }}
                                      style={{ width: "100%" }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={translate(
                                            "resources.home.selectstore"
                                          )} //""Выберите супервайзера" //Выберите Тип доступа"
                                          variant="outlined"
                                          //          variant="standard"
                                          //          placeholder="Выберите Мастера"
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                              <List
                                style={{
                                  //maxHeight: "700px",
                                  overflow: "auto",
                                  height: "100%", //380,
                                }}
                              >
                                <GridTable
                                  //enableColumnsReorder={false}
                                  //isPageSize={false}
                                  //showSearch={false}
                                  //showRowsInformation={false}
                                  style={{
                                    //marginTop:-10,
                                    //height: "95%",
                                    //input: access.user.theme === "dark" ? "" : "",
                                    "--rgt-background-color-input":
                                      access.user.theme === "dark"
                                        ? "grey"
                                        : "#fff",
                                    "--rgt-color-input":
                                      access.user.theme !== "dark"
                                        ? "#000"
                                        : "#fff",
                                    "--rgt-color-search2":
                                      access.user.theme === "dark"
                                        ? "#000"
                                        : "#fff",

                                    "--rgt-background-color":
                                      access.user.theme === "dark"
                                        ? "#000"
                                        : "#fff",
                                  }}
                                  tableHasSelection={true}
                                  searchText={searchText}
                                  onSearchTextChange={(e) => {
                                    setSearchText(e.target.value);
                                  }}
                                  //showColumnVisibilityManager={false}
                                  columns={columns2}
                                  //pageSizes={[10, 20, 30]}
                                  pageSizes={[10]}
                                  rows={rows}
                                />
                              </List>

                              {/*
                              <List
                                style={{
                                  maxHeight: "600px",
                                  overflow: "auto",
                                  height: "100%", //380,
                                }}
                              >
                                <Styles>
                                  <Table_PD
                                    columns={columns12}
                                    data={data12}
                                    getHeaderProps={
                                      (nameTheme &&
                                        nameTheme !== "dark" &&
                                        ((row) => {
                                          return {
                                            style: {
                                              //                   background:
                                              //                   row.index % 2 === 0 ? 'rgba(0,0,0,.1)' : 'white',
                                            },
                                          };
                                        })) ||
                                      ((row) => {
                                        return {
                                          style: {
                                            color: "#ffffffb3",
                                            //                    background:
                                            //                    row.index % 2 === 0 ? 'rgba(0,0,0,.1)' : '#ffffffb3', //'#616161e6', //'#ffffffb3',
                                          },
                                        };
                                      })
                                    }
                                 
                                    getRowProps={
                                      (nameTheme &&
                                        nameTheme !== "dark" &&
                                        ((row) => {
                                          return {
                                            style: {
                                              background:
                                                row.index % 2 === 0
                                                  ? "rgba(0,0,0,.1)"
                                                  : "white",
                                            },
                                          };
                                        })) ||
                                      ((row) => {
                                        return {
                                          style: {
                                            background:
                                              row.index % 2 === 0
                                                ? "rgba(0,0,0,.1)"
                                                : "#616161e6", //'#ffffffb3',
                                          },
                                        };
                                      })
                                    }
                                    getCellProps={(cellInfo) => ({
                                      //            onClick: (req, res) => onClickCell(cellInfo, req, res),
                                      //            style: {
                                      //              backgroundColor: `hsl(${
                                      //                120 * ((120 - cellInfo.value) / 120) * -1 + 120
                                      //              }, 100%, 67%)`,
                                      //            },
                                    })}
                                  />
                                </Styles>
                              </List>
                              */}
                            </CardContent>
                          </Card>
                        </Box>
                      }
                    </div>
                  </TabPanel>
                  <TabPanel value="2" sx={{ p: 0 }}>
                    <div
                      style={{ marginTop: 0, height: !isXSmall ? 600 : 400 }}
                    >
                      {
                        <Box>
                          <Card
                            sx={{
                              minWidth: 275,
                              height: !isXSmall ? 680 : 400,
                            }}
                          >
                            <CardContent>
                              <div
                                //            className="hstack gap-2"
                                style={{
                                  marginTop: 0,
                                  display: "flex",
                                  height: "100%",

                                  //justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  id="outlined-basic"
                                  label="Клиент"
                                  //variant="standard"
                                  className="title h6"
                                  style={{
                                    marginTop: 0,
                                    marginBottom: 15,
                                    marginRight: 40,
                                    //display: 'flex',
                                    //justifyContent: 'space-between',
                                  }}
                                >
                                  {UserSupervisorname}
                                  {/*translate("resources.home.store") + " :"*/}
                                </Typography>
                              </div>
                              <List
                                style={{
                                  maxHeight: "600px",
                                  overflow: "auto",
                                  height: "100%", //380,
                                }}
                              >
                                <Styles>
                                  <Table2
                                    columns={columns3}
                                    data={data3}
                                    getHeaderProps={
                                      (nameTheme &&
                                        nameTheme !== "dark" &&
                                        ((row) => {
                                          return {
                                            style: {
                                              //                   background:
                                              //                   row.index % 2 === 0 ? 'rgba(0,0,0,.1)' : 'white',
                                            },
                                          };
                                        })) ||
                                      ((row) => {
                                        return {
                                          style: {
                                            color: "#ffffffb3",
                                            //                    background:
                                            //                    row.index % 2 === 0 ? 'rgba(0,0,0,.1)' : '#ffffffb3', //'#616161e6', //'#ffffffb3',
                                          },
                                        };
                                      })
                                    }
                                    /*          
          getHeaderProps={(column) => ({
            onClick: () => alert('Header!'),
          })}
          getColumnProps={(column) => ({
            onClick: () => alert('Column!'),
          })}
          */
                                    getRowProps={
                                      (nameTheme &&
                                        nameTheme !== "dark" &&
                                        ((row) => {
                                          return {
                                            style: {
                                              background:
                                                row.index % 2 === 0
                                                  ? "rgba(0,0,0,.1)"
                                                  : "white",
                                            },
                                          };
                                        })) ||
                                      ((row) => {
                                        return {
                                          style: {
                                            background:
                                              row.index % 2 === 0
                                                ? "rgba(0,0,0,.1)"
                                                : "#616161e6", //'#ffffffb3',
                                          },
                                        };
                                      })
                                    }
                                    getCellProps={(cellInfo) => ({
                                      //            onClick: (req, res) => onClickCell(cellInfo, req, res),
                                      //            style: {
                                      //              backgroundColor: `hsl(${
                                      //                120 * ((120 - cellInfo.value) / 120) * -1 + 120
                                      //              }, 100%, 67%)`,
                                      //            },
                                    })}
                                  />
                                </Styles>
                              </List>
                            </CardContent>
                          </Card>
                        </Box>
                      }
                    </div>
                  </TabPanel>
                </TabContext>
              </Box>
            </Box>
          </LocalizationProvider>
          {/* Alert Dialog */}
        </>
      )}
      {!ready() && (
        <>
          <Box maxWidth={maxwidth}>
            <Card>
              <CardContent>
                <Spinner />
              </CardContent>
            </Card>
          </Box>
        </>
      )}
    </>
  );

  const alert1 = <ModaltDialog />;

  return !openAlertDialog ? main : alert1;
};

export default Home;
